import './About.css';

export const About = () => {
  return (
      <>
        <section className="snn-page-section">
          <div className="snn-about">
              <section id="snn-committee">
                  <section className="snn-page-section">
                      <h2 className="snn-title">Organizing Committee ESD 2025</h2>
                      <div className="snn-scientific-committee">
                          <section>
                              <ul>
                                  <li>Ana Karina Cuentas Gallegos CHAIR</li>
                                  <li>Christian A. Celaya</li>
                                  <li>Carolina Bohórquez Martínez</li>
                                  <li>Hugo Tiznado</li>
                                  <li>Javier López</li>
                                  <li>Yasmín Esqueda Barrón</li>
                                  <li>Jassiel Rodriguez Barreras</li>
                                  <li>Jonathan Guerrero</li>
                                  <li>Irene Barberena Rojas</li>
                              </ul>
                          </section>
                      </div>
                  </section>
              </section>
              <section id="history">
                  <h2 className="snn-title">History</h2>
                  <div className="elementor-element elementor-element-1cfa43a e-con-full e-flex e-con e-child"
                       data-id="1cfa43a" data-element_type="container"
                       data-settings="{&quot;background_background&quot;:&quot;gradient&quot;,&quot;jet_parallax_layout_list&quot;:[],&quot;_ha_eqh_enable&quot;:false}">
                  </div>
                  <p className="snn-justify">
                      Energy Storage Discussions is a forum for the analysis of various aspects of energy storage,
                      established in 2014. In the era of renewable energy and mobile electronics, the need for better
                      energy storage devices is more evident than ever. This conference brings together experts from materials science, electrochemistry, power electronics, and control systems, as well as interdisciplinary fields like nanotechnology, to discuss advancements in energy storage.
                  </p>
                  <p className="snn-justify">
                      The 2014, 2016, 2017, 2019, and 2023 editions of the conference have been highly successful, making it the flagship event of the CONAHCyT Energy Storage Network. The most recent edition, Energy Storage Discussions 2023, was held in Monterrey, Mexico, continuing the tradition of fostering scientific collaboration and innovation.
                  </p>
              </section>
          </div>
        </section>

      </>
  );
};
